import axios from 'axios';

/**
 * Metodo para obtener un token de logeo de app hacia mvc
 * @param {} Token 
 * @returns object con token
 */
export const Token = async () => {
    try {

      const params = new URLSearchParams();
      params.append('grant_type', process.env.REACT_APP_TOKEN_CLIENT_GRANT_TYPE);
      params.append('client_id', process.env.REACT_APP_TOKEN_CLIENTE_ID);
      params.append('client_secret', process.env.REACT_APP_TOKEN_PWD);

      const response = await axios.post(process.env.REACT_APP_TOKEN + '/connect/token', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        timeout: 5000
      });
      return response;
    } catch (error) {
      console.error('Error obtaining token:', error.message);
      return false;
    }
    
  };